/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Overlap_TitleInputs */

const en_event_warning_overlap_title = /** @type {(inputs: Event_Warning_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overlaps detected`)
};

const fr_event_warning_overlap_title = /** @type {(inputs: Event_Warning_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chevauchements détectés`)
};

const de_event_warning_overlap_title = /** @type {(inputs: Event_Warning_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappungen erkannt`)
};

const it_event_warning_overlap_title = /** @type {(inputs: Event_Warning_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovrapposizioni rilevate`)
};

const ru_event_warning_overlap_title = /** @type {(inputs: Event_Warning_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружены пересечения`)
};

const es_event_warning_overlap_title = /** @type {(inputs: Event_Warning_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se detectaron superposiciones`)
};

const zh_cn2_event_warning_overlap_title = /** @type {(inputs: Event_Warning_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测到重叠`)
};

const ja_event_warning_overlap_title = /** @type {(inputs: Event_Warning_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複が検出されました`)
};

const hi_event_warning_overlap_title = /** @type {(inputs: Event_Warning_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरलैप का पता चला`)
};

const pt_pt2_event_warning_overlap_title = /** @type {(inputs: Event_Warning_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobreposições detectadas`)
};

/**
* | output |
* | --- |
* | "Overlaps detected" |
*
* @param {Event_Warning_Overlap_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_overlap_title = /** @type {((inputs?: Event_Warning_Overlap_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Overlap_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_overlap_title(inputs)
	if (locale === "de") return de_event_warning_overlap_title(inputs)
	if (locale === "it") return it_event_warning_overlap_title(inputs)
	if (locale === "ru") return ru_event_warning_overlap_title(inputs)
	if (locale === "es") return es_event_warning_overlap_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_overlap_title(inputs)
	if (locale === "ja") return ja_event_warning_overlap_title(inputs)
	if (locale === "hi") return hi_event_warning_overlap_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_overlap_title(inputs)
	return en_event_warning_overlap_title(inputs)
});